<div class="logo-container" mat-button [matMenuTriggerFor]="menu">
  <div class="logo">
    {{ utilService.userLogoText }}
  </div>
</div>
<mat-menu #menu="matMenu">
  <button mat-menu-item button >
    <div class="settings">
       <div class="user-trainer-container">
        <div [ngClass]="{'user-mode': !utilService.trainerMode, 'trainer-mode': utilService.trainerMode}" (click)="switchMode(true)">
              <ion-img src="assets/images/user-active.svg" class="switch-mode-img" *ngIf="!utilService.trainerMode" >  </ion-img>
                <ion-img src="assets/images/user-inactive.svg" class="switch-mode-img" *ngIf="utilService.trainerMode" >
              </ion-img>
              <ion-text>
                User
              </ion-text>
        </div>
        <div [ngClass]="{'user-mode':utilService.trainerMode,'trainer-mode':!utilService.trainerMode}" (click)="switchMode(false)">
          <ion-img src="assets/images/trainer-inactive.svg"class="switch-mode-img" *ngIf="!utilService.trainerMode" >  </ion-img>
            <ion-img src="assets/images/trainer-active.svg" class="switch-mode-img" *ngIf="utilService.trainerMode" ></ion-img>
          <ion-text>
            Trainer
          </ion-text>

        </div>
       </div>
    </div>
  </button>
  <button mat-menu-item button (click)="profileModalOpen(true)">
    <div class="settings">
      <ion-img src="assets/images/user.svg"></ion-img>
      <span>Profile Settings</span>
    </div>
  </button>
  <ion-modal #modal [isOpen]="isProfileOpen" backdropDismiss="false">
    <ng-template>
      <app-user-profile (closeModal)="modalDismiss()" (openModal)="passcodeModalOpen()"></app-user-profile>
    </ng-template>
  </ion-modal>
  <ion-modal #modal [isOpen]="isPasscodeOpen" class="passcodeModal" backdropDismiss="false">
    <ng-template>
      <form class="passcode-edit-container" [formGroup]="passcodeForm" (ngSubmit)="reset()">
        <ion-label>Reset Passcode</ion-label>
        <ion-row>
          <ion-col class="passcode-label" size="3">Old Passcode</ion-col>
          <ion-col>
            <div class="input-class">
              <ion-input formControlName="oldPasscode" class="edit-input" maxLength="6"></ion-input>
              <ion-label class="err-message">{{oldPasscodeError}}</ion-label>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="passcode-label" size="3">New Passcode</ion-col>
          <ion-col>
            <div class="input-class"><ion-input formControlName="newPasscode" maxLength="6"
                class="edit-input"></ion-input><ion-label class="err-message">{{newPasscodeError}}</ion-label>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="passcode-label" size="3">Confirm Passcode</ion-col>
          <ion-col>
            <div class="input-class"><ion-input formControlName="confirmPasscode" maxLength="6"
                class="edit-input"></ion-input><ion-label class="err-message">{{confirmPasscodeError}}</ion-label>
            </div>
          </ion-col>

        </ion-row>
        <div class="btns">
          <app-submit buttonText="Cancel" buttonType="rectCancel"buttonSubmitType="button" (click)="passcodeModalClose();$event.preventDefault()"></app-submit>

          <app-submit buttonText="Reset" buttonType="rectSave" buttonSubmitType="submit"  [buttonDisabled]="isResetDisabled()"></app-submit>
        </div>

      </form>
    </ng-template>
  </ion-modal>
 
  <button mat-menu-item button (click)="logout()">
    <div class="settings">
      <ion-img src="assets/images/logout.svg"></ion-img>
      <span>Logout</span>
    </div>
  </button>
</mat-menu>
<ion-modal #modal [isOpen]="resetConfirm" class="confirmModal"  backdropDismiss="false">
  <ng-template>
    <div class="passcode-reset-container">
      <ion-label class="confirmation-title">Reset Password Confirmation</ion-label>

      <ion-label class="confirmation-note">
        After your password is successfully reset, you will be redirected to the login page.
      </ion-label>

      <div class="reset-btns">
        <app-submit buttonText="Cancel" buttonType="rectCancel" (click)="resetClose()"></app-submit>

        <app-submit buttonText="Confirm" buttonType="rectSave" (click)="resetPassword()" ></app-submit>
      </div>

    </div>
    <div class="spinner"  *ngIf="!utilService.dataLoaded"> <app-spinner ></app-spinner></div>
  </ng-template>
</ion-modal>